import { useEffect, useCallback, useMemo, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import ChannelsMetaTags from "@/components/MetaTags/ChannelsMetaTags";
import TabMenu from "@/components/TabMenu";
import DropdownSelect from "@/components/DropdownSelect";
const ChannelsList = dynamic(() => import("@/components/ChannelsList"));
const HtmlSnippet = dynamic(() => import("@/components/HtmlSnippet"));
import NoContentMessage from "@/components/NoContentMessage";
import { useBreadcrumbs } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { channelsSort } from "@/lib/sorts";
import styles from "@/styles/Channel.module.scss";
import contentsStyles from "@/styles/Contents.module.scss";

const menus = [
  { text: "すべて", link: { href: routes.channels, shallow: true } },
  { text: "契約中", link: { href: routes.channelsEntitled, shallow: true } },
  { text: "未契約", link: { href: routes.channelsUnentitled, shallow: true } },
];

export default function Channels() {
  const router = useRouter();
  const { setBreadcrumbs } = useBreadcrumbs();
  const [sort, setSort] = useState(channelsSort[0].value);

  const handleSelect = useCallback((selectedSort) => {
    setSort(selectedSort.value);
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { text: "ホーム", href: routes.home },
      { text: "月額商品一覧" },
    ]);
  }, []);

  const entitled = useMemo(() => {
    if (router.asPath === routes.channels) {
      return null;
    } else if (router.asPath === routes.channelsEntitled) {
      return true;
    } else if (router.asPath === routes.channelsUnentitled) {
      return false;
    }
  }, [router.asPath]);

  const snippetKey = useMemo(() => {
    return config.htmlSnippet.channels.vod;
  }, []);

  const mode = useMemo(() => {
    if (entitled === true) return "entitled";
    if (entitled === false) return "unentitled";
    return "all";
  }, [entitled]);

  return (
    <>
      <ChannelsMetaTags mode={mode} />
      <div className={`${contentsStyles.container} ${styles.list}`}>
        {snippetKey && <HtmlSnippet idKey={snippetKey} />}
        <header>
          <h1>月額商品一覧</h1>
        </header>
        <nav className={contentsStyles.withSort}>
          <TabMenu menus={menus} />
          <DropdownSelect
            right
            options={channelsSort}
            onSelect={handleSelect}
            className={"sort"}
          />
        </nav>
        <ChannelsList
          entitled={entitled}
          sort={sort}
          noContent={<NoContentMessage message="月額商品がありません" />}
        />
      </div>
    </>
  );
}
